import { useTranslation } from "react-i18next";
import { PaywallProps } from ".";
import { Button, Text } from "../common";
import {
  Body,
  Container,
  Footer,
  Header,
  PlanContainer,
  TextShadow,
} from "./index.styled";
import { useMemo } from "react";


const PricingPaywall: React.FC<PaywallProps> = ({
  handleClose,
  handleAccept,
  plans,
}) => {
  const { t } = useTranslation("private-home-page", { keyPrefix: "paywall" });
  const plan = useMemo(() => plans.find((plan) => !plan.yearly_amount), [plans]);

  return (
    <Container widthRem={30}>
        <Header
          url="https://hermes.digitalinnovation.one/assets/talent-header.png"
          minHeight="16rem"
        >
          <TextShadow
            as="p"
            fontSize={34}
            fontWeight={700}
            color={"#7F28B5"}
            maxWidth={245}
            lineHeight={30}
            margin=".5rem 1.5rem"
            shadow="0px 0px 20px rgba(127, 40, 181, 0.2)"
          >
            {t("title")}
          </TextShadow>
          <TextShadow
            as="p"
            fontSize={14}
            fontWeight={400}
            color={"#424242"}
            maxWidth={180}
            lineHeight={18}
            margin="1rem 1.5rem"
            shadow="#FFF 0 0 50px"
            dangerouslySetInnerHTML={{ __html: t("desc", { plan: plan?.name}) }}
          />
        </Header>
        <Body>
          <PlanContainer>
            <Text as="p" fontSize={26} fontWeight={700} color={"#7F28B5"} margin="0">
              {plan?.name}
            </Text>
            <Text as="p" fontSize={42} fontWeight={700} color={"#000"} margin="0">
              {t("price", { price: plan?.monthly_amount })}
            </Text>
            <Text as="p" fontSize={16} fontWeight={400} color={"#000"} margin="0">
              {t("anual")}
            </Text>
          </PlanContainer>
          <Text as="p" fontSize={16} fontWeight={400} color={"#595959"} margin="1.25rem 0">
            {t("body-desc")}
          </Text>
        </Body>
        <Footer>
          <Button
            backgroundColor="#049EFB"
            textColor="#fff"
            onClick={() => {
              handleAccept();
            }}
            width="100%"
            margin="0"
            fontSize={14}
            fontWeight={700}
            padding="1rem"
          >
            {t("spec")}
          </Button>
        </Footer>
      </Container>
  )
};

export default PricingPaywall;
